/**
 * 日期选择器
 * 
 * @Author: Focci
 * @Date: 2024-12-18 10:37:35
 * @Last Modified by: Focci
 * @Last Modified time: 2024-12-18 10:37:35
 */

'use client'

// import PropTypes from 'prop-types'
import DropdownMenu from '@comp/DropdownMenu'
import useProgressRouter from '@hook/useProgressRouter'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { isArray, isFunction, map } from 'lodash-es'
import { useCallback, useMemo } from 'react'
import { auctionHome, auctionDetail } from '@lib/route/house'
import { useLocale } from 'next-intl'

const routeCallbacks = {
  home: (slug, locale) => auctionHome(slug, locale),
  detail: (slug, locale) => auctionDetail(slug, locale),
}

export default function DatePicker({
  data,
  value,
  prefix,
  routeType = 'home'
}) {
  const locale = useLocale()
  const { routerPush } = useProgressRouter()

  const options = useMemo(() => (
    map(isArray(data) ? data : [], (it) => ({
      label: it.label,
      value: `${it.startDate}-${it.endDate}`,
    }))
  ), [data])

  const label = useMemo(() => {
    const res = options.find((it) => it.value === value)
    return res?.label || options[0]?.label
  }, [options, value])

  const handleChange = useCallback((v) => {
    const fn = routeCallbacks[routeType]
    if(isFunction(fn) && v.value !== value) {
      const slug = []
      prefix && slug.push(prefix)
      slug.push(v.value)

      const url = fn(slug.join('/'), locale)
      url && routerPush(url)
    }
  }, [locale, routerPush, routeType, prefix, value])

  return (
    <DropdownMenu
      options={options}
      onChange={handleChange}
      value={value}
      trigger={
        <div className="w-72 max-w-full border p-2 rounded-sm flex items-center justify-between">
          <span className="line-clamp-1">
            {label}
          </span>
          <KeyboardArrowDownIcon />
        </div>
      }
    />
  )
}

// DatePicker.propTypes = {
//   className: PropTypes.string,
// }
